import {TweenLite} from 'gsap';

export default class NavComponent {
  static CLASSES = {
    NAV: 'nav',
    SUBLIST: 'nav__sublist',
    SUBITEM: 'nav__subitem',
    SUBLINK: 'nav__sublink',
    SUBLINK_ACTIVE: 'nav__sublink--active'
  };

  static init($nav) {
    if (!$nav || $nav.navComponent) {
      return;
    }

    $nav.navComponent = new NavComponent($nav);
  }

  static initAll() {
    document.querySelectorAll(`.${NavComponent.CLASSES.NAV}`).forEach(($nav) => {
      NavComponent.init($nav);
    });
  }

  constructor($nav) {
    this.$nav = $nav;
    this.$$sublist = $nav.querySelectorAll(`.${NavComponent.CLASSES.SUBLIST}`);
    this.$$sublistForSelect = $nav.querySelectorAll(
      `.${NavComponent.CLASSES.SUBLIST}[data-for-select]`
    );

    this.onResizeWindow = this.onResizeWindow.bind(this);
    this.onClickSublistForSelect = this.onClickSublistForSelect.bind(this);

    this.init();
  }

  init() {
    if (this.$$sublist.length) {
      this.updateSublistPosition();
      window.addEventListener('resize', this.onResizeWindow);

      this.$$sublistForSelect.forEach(($sublist) => {
        $sublist.addEventListener('click', this.onClickSublistForSelect);
      });
    }
  }

  destroy() {
    if (this.$$sublist.length) {
      window.removeEventListener('resize', this.onResizeWindow);

      this.$$sublistForSelect.forEach(($sublist) => {
        $sublist.removeEventListener('click', this.onClickSublistForSelect);
      });
    }

    this.$nav.navComponent = null;
  }

  onResizeWindow() {
    this.updateSublistPosition();
  }

  onClickSublistForSelect(event) {
    let $target = event.target;

    while ($target !== event.currentTarget) {
      if ($target.classList.contains(NavComponent.CLASSES.SUBLINK)) {
        this.selectSublink($target);
        event.preventDefault();
        break;
      }

      $target = $target.parentElement;
    }
  }

  updateSublistPosition() {
    let bodyWidth = document.body.clientWidth;

    this.$$sublist.forEach(($sublist) => {
      let $item = $sublist.parentElement;
      let rect = $item.getBoundingClientRect();
      let sublistLeft = window.pageXOffset + rect.left;
      let sublistWidth = 235;
      let rightSpace = 5;
      let x = Math.min(bodyWidth - (sublistLeft + sublistWidth + rightSpace), 0);

      TweenLite.set($sublist, {x});
    });
  }

  selectSublink($sublink) {
    let $sublist = $sublink.parentElement.parentElement;
    let $$sublinks = Array.from($sublist.querySelectorAll(`.${NavComponent.CLASSES.SUBLINK}`));
    let forSelect = $sublist.dataset.forSelect;
    let selectedIndex = $$sublinks.indexOf($sublink);

    if (selectedIndex !== -1) {
      $$sublinks.forEach(($s) => {
        if ($s !== $sublink && $s.classList.contains(NavComponent.CLASSES.SUBLINK_ACTIVE)) {
          $s.classList.remove(NavComponent.CLASSES.SUBLINK_ACTIVE);
        }
      });

      $sublink.classList.add(NavComponent.CLASSES.SUBLINK_ACTIVE);

      this.updateSelect(forSelect, selectedIndex);
    }
  }

  updateSelect(id, selectedIndex) {
    let $select = document.getElementById(id);

    if (!$select) {
      return;
    }

    $select.selectedIndex = selectedIndex;

    let changeEvent;

    if (typeof window.CustomEvent === 'function') {
      changeEvent = new CustomEvent('change', {
        bubbles: true,
        cancelable: false
      });
    } else {
      changeEvent = document.createEvent('HTMLEvents');
      changeEvent.initEvent('change', true, false);
    }

    $select.dispatchEvent(changeEvent);
  }
}
